<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()" :style="{ '--tint': tintColor }">
    <span :class="b('sweep')" aria-hidden="true"></span>
    <div :class="b('row-currency')">
      <span
        :class="b('row-icon', { currency: currencyCode.toLowerCase() })"
        aria-hidden="true"
        >{{ currencySymbol }}</span
      >
      <div :class="b('row-currency-group')">
        <span :class="b('row-currency-label')">{{ currencyCode }}</span>
        <span :class="b('row-currency-name')">{{ $t(currencyTitle) }}</span>
      </div>
    </div>
    <div :class="b('row-type')">
      <span :class="b('row-currency-tag', { crypto: row.type === 'crypto' })">
        {{ $t(row.type === "fiat" ? "Банковский счёт" : "Крипто-счёт") }}
      </span>
    </div>
    <div :class="b('row-total')">
      <p :class="b('row-total-label', { zero: !Number(row.amount) })">
        {{ displayedAmount }}
      </p>
      <p v-if="usdEquivalent" :class="b('row-equivalent')">
        {{ usdEquivalent }}
      </p>
    </div>
    <div :class="b('row-actions')">
      <button
        :class="b('row-action')"
        @click="handleDeposit"
        :disabled="notVerified"
        :aria-label="$t('Пополнить')"
        v-tooltip="
          notVerified
            ? $t('Для получения доступа пройдите процедуру верификации')
            : $t('Пополнить')
        "
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 5v14M6 13l6 6 6-6" />
        </svg>
      </button>
      <button
        :class="b('row-action')"
        @click="handleWithdrawal"
        :disabled="!(row.amount > 0)"
        :aria-label="$t('Вывести')"
        v-tooltip="$t('Вывести')"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 19V5M6 11l6-6 6 6" />
        </svg>
      </button>
      <button
        :class="b('row-action')"
        @click="handleApplication"
        :disabled="!(row.amount > 0)"
        :aria-label="$t('Торговать')"
        v-tooltip="$t('Торговать')"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 8h13l-3-3M20 16H7l3 3" />
        </svg>
      </button>
      <button
        :class="b('row-action')"
        @click="handleHistory"
        :disabled="notVerified"
        :aria-label="$t('История Выводов/Пополнений')"
        v-tooltip="
          notVerified
            ? $t('Для получения доступа пройдите процедуру верификации')
            : $t('История Выводов/Пополнений')
        "
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="8" />
          <path d="M12 7v5l3 2" />
        </svg>
      </button>
    </div>
  </div>
</template>
